import React, { useEffect, useState } from 'react';
import { Typography, notification, Button, Modal, Table } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from '../../redux/modules/course';

import DrawerForm from '../../components/basic/drawer';
import SentenceForm from './components/sentenceForm';
import { FormattedMessage, useIntl } from 'react-intl';
import 'antd/dist/antd.min.css';
import Common from '../../lib/common';
import CONSTANTS from '../../lib/constants';
import APIServices from '../../lib/APIServices';

const { ACTION_KEY } = CONSTANTS;
const { getAllSentence } = actions;
const { Title } = Typography;
const { confirm } = Modal;
const { getPageTitleName } = Common;

interface Pagination {
    current: number
    pageSize: number
    showSizeChanger?: boolean
    total?: number
}
interface DefaultRootState {
    user: {
        userActions: Array<number>
    }
    course: {
        allSentence: Array<any>
    }
}

interface DrawerInfo {
    // isCreate: boolean
    title: any,
    type: string
    initialValues?: any | undefined
}

interface Props {
    courseId: string
}

const WordView = (props: Props) => {
    const [pagination, setPagination] = useState<Pagination>({
        current: 1,
        pageSize: 20,
        showSizeChanger: true,
    });
    const [drawer, setDrawer] = useState<DrawerInfo>({
        // isCreate: true,
        title: '',
        type: '',
    });
    const [visible, setVisible] = useState<boolean>(false);
    const intl: { formatMessage: (id: { id: string }) => string } = useIntl();
    const { allSentence, userActions } = useSelector((state: DefaultRootState) => ({
        allSentence: state.course.allSentence,
        userActions: state.user.userActions,
    }));
    const dispatch = useDispatch();

    // config table title
    const titleData = ['lessonName', 'deleteTip', 'action'];
    const titleName = getPageTitleName(titleData, intl.formatMessage);

    const refreshList = () => {
        dispatch(getAllSentence());
    };

    const showDrawer = (item?: { _id: string }) => {
        const data = item && item._id
            ? {
                title: 'Update Word',
                type: 'update',
                visible: true,
                initialValues: item,
            }
            : {
                title: 'Create Word',
                type: 'create',
                visible: true,
            };
        setDrawer(data);
        setVisible(true);
    };

    const deleteList = async (id: string) => {
        await APIServices.deleteSentence(id);
        notification.success({
            message: 'Delete Success',
            description: '删除成功',
            placement: 'topRight',
        });
        refreshList();
    };

    const onClose = () => {
        setDrawer({ ...drawer, initialValues: '' });
        setVisible(false);
    };

    const onSubmit = async (values: any) => {
        if (values._id) {
            // dispatch(updateWord(values));
            await APIServices.updateSentence(values);
        } else {
            // dispatch(createWord(values));
            await APIServices.createSentence(values);
        }
        onClose();
        refreshList();
    };

    const setPaginationParams = (paginationInfo: any) => {
        setPagination(paginationInfo);
    };

    const columns = [
        {
            title: '插画',
            dataIndex: 'eikon',
            key: 'eikon',
            // eslint-disable-next-line react/display-name
            render: (_text: {}, formValues: any) => {
                const src = formValues.eikon;
                return (
                    <div className='eikon-img'>
                        <img width={100} src={src} />
                    </div>
                );
            },
        },
        {
            title: '句子',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: '排序',
            dataIndex: 'order',
            key: 'order',
        },
        {
            title: '操作',
            key: 'action',
            fixed: 'right',
            // eslint-disable-next-line react/display-name
            render: (text: {}, formValues: { content: string, _id: string }) =>
                <span>
                    <Button
                        icon={<EditOutlined />}
                        type='text'
                        disabled={!userActions.includes(ACTION_KEY.EDIT)}
                        onClick={() => showDrawer(formValues)}
                    ></Button>
                    <Button
                        icon={<DeleteOutlined />}
                        type='text'
                        disabled={!userActions.includes(ACTION_KEY.DELETE)}
                        onClick={() => {
                            confirm({
                                title: `Are you sure you want to delete ${formValues.content}?`,
                                icon: <ExclamationCircleOutlined />,
                                okType: 'danger',
                                onOk() {
                                    deleteList(formValues._id);
                                },
                            });
                        }}
                    >
                    </Button>
                </span>,
        },
    ];

    useEffect(() => {
        refreshList();
    }, [pagination.current, pagination.pageSize]);
    return (
        <div>
            <Title>Sentence</Title>
            <Button
                shape='circle'
                size='large'
                icon={<PlusOutlined />}
                onClick={() => showDrawer()}
                type='primary'
                disabled={!userActions.includes(ACTION_KEY.CREATE)}
                className='plusIcon'
            >
            </Button>
            <Table
                rowKey={(data: { _id: string }) => data._id}
                columns={columns as Array<object>}
                dataSource={allSentence as Array<{ _id: string }>}
                pagination={pagination}
                onChange={paginationInfo => setPaginationParams(paginationInfo)}
            />

            {
                visible &&
                <DrawerForm
                    {...drawer}
                    visible
                    onClose={onClose}
                >
                    <SentenceForm
                        onClose={onClose}
                        initialValues={drawer.initialValues}
                        onSubmit={onSubmit}
                    />
                </DrawerForm>
            }
        </div>
    );
};


export default WordView;
